import React, { useEffect, useState, useContext } from "react";
import Chip from '@mui/material/Chip';
import {withStyles} from "@mui/styles";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";
import {FilterContext, FilterDispatchContext} from "contexts/filterContext";

function FilterChip(props) {
    const {classes} = props;
    const [clicked, setClicked] = useState(false);
    const dispatch = useContext(FilterDispatchContext);
    const { filters } = useContext(FilterContext);

    const handleClick = (item) => {
        dispatch({
            type: 'filter',
            item: item
        });
    };

    useEffect(() => {
        let f = filters.find(f => f.id === props.item.id);
        f === undefined ? setClicked(false) : setClicked(true);
    }, [filters]);

    return (
        <Chip
            label={props.label}
            // the pill style (filterItem) keys off the outlined variant:
            // outlined = unselected, filled = selected
            variant={clicked ? "filled" : "outlined"}
            onClick={() => handleClick(props.item)}
            classes={{root: classes.filterItem}}
            sx={props.sx}
        />
    );
}

export default withStyles(filterMenuStyle)(FilterChip);
